/* Modal — MUI Dialog wrapper (PS.modal equivalent). The Paper carries the
   `.supply-scope` class so the scoped mockup CSS + CSS vars resolve inside the
   portal, with a white surface (overriding the page's grey scope background).

   props:
     open, onClose, title, icon(node), children, width (e.g. 600 | '60vw'),
     actions: [{label, onClick, primary, danger, icon(node), disabled, closeOnClick=true}]
*/
import React from 'react'
import PropTypes from 'prop-types'
import {Dialog, IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {cx} from './helpers'

export default function Modal({open, onClose, title, icon, children, actions = [], width = 520}) {
  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        className: 'supply-scope ss-modal-paper',
        sx: {
          bgcolor: '#fff',
          color: 'text.primary',
          borderRadius: '8px',
          width: typeof width === 'number' ? `${width}px` : width,
          maxWidth: '97vw',
          m: 2,
          height: 'auto', // .supply-scope{height:100%} would stretch the Paper to full viewport
        },
      }}
    >
      <div className='modal-head' style={{position: 'relative'}}>
        <h3 style={{paddingRight: 40}}>
          {icon}
          {title}
        </h3>
        <IconButton
          className='iconbtn'
          size='small'
          onClick={onClose}
          sx={{position: 'absolute', right: 8, top: 8}}
          aria-label='Close'
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      </div>
      <div className='modal-body'>{children}</div>
      {actions.length > 0 && (
        <div className='modal-foot'>
          {actions.map((a, i) => (
            <button
              type='button'
              key={a.label || i}
              className={cx('btn', a.danger ? 'btn-danger' : a.primary && 'btn-primary')}
              disabled={a.disabled}
              onClick={() => {
                const r = a.onClick ? a.onClick() : undefined
                if (r !== false && a.closeOnClick !== false && onClose) onClose()
              }}
            >
              {a.icon}
              {a.label}
            </button>
          ))}
        </div>
      )}
    </Dialog>
  )
}

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  icon: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.array,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
